import { messages } from '../shared/messages.js';
import { ViewerShell } from '../shared/shell.js';
import { tokenFromLocation } from './token.js';

/**
 * V02 単体プレビューページ。
 *
 * 正本は [#33](../../../../docs/issues/33-viewer-embed/DESIGN.md)。
 *
 * **V01(embed.js)との差分は「入口と外枠」だけ**で、ビューアシェルと
 * 描画コアは共有する。V02 は [ADR-0003](../../../../docs/adr/0003-embed-js-sdk-with-iframe.md)
 * が定めた **iframe 補助手段の実体**でもあるため、**V02 が単独で成立している
 * ことが V01 の逃げ道の前提**になる。
 *
 * V01 との違い:
 * - Shadow DOM を使わない(埋め込み先の CSS と衝突する相手がいない)
 * - トークンは URL から取る
 * - `CustomEvent` を出さない(購読する相手がいない)
 * - サイズはビューポートに追従する
 */

const container = document.querySelector('#viewer');
if (!(container instanceof HTMLElement)) {
  throw new Error('#viewer が見つかりません');
}

/*
 * ビューポートに追従させる(V01 は埋め込み先の幅に追従)。
 *
 * **`min-height` は `dvh` で二重に書く**(#212)。`vh` はモバイルで
 * **アドレスバーを含まない最大の高さ**なので、バーが出ている間は画面より
 * 大きく、**それだけでスクロールが生まれる。** 非対応のブラウザは
 * 2 つ目の宣言を捨てて `vh` を使う。
 */
document.body.setAttribute(
  'style',
  [
    'margin: 0;',
    'min-height: 100vh;',
    'min-height: 100dvh;',
    'display: flex;',
    'align-items: center;',
    'justify-content: center;',
    'background: #2b2b2f;',
  ].join(' '),
);
container.setAttribute('style', 'width: 100%; max-width: 100vw;');

const token = tokenFromLocation(globalThis.location);

if (token === null) {
  // **トークンが取れないのは URL の誤り。** 公開 API を叩く前に止める。
  const notice = document.createElement('p');
  notice.textContent = messages('ja').notAvailable;
  notice.setAttribute('style', 'color: #ffffff; font-family: system-ui, sans-serif;');
  container.append(notice);
} else {
  const shell = new ViewerShell(container, {
    token,
    // 同一オリジンで配信する(ビューアと公開 API は CloudFront の後ろ)。
    apiBase: globalThis.location.origin,
    fit: 'contain',
    /*
     * **画面に収める**(#212)。V02 は盤面だけを見せる画面なので、
     * **スクロールしないと全体が見えない状態を作らない。**
     *
     * V01(埋め込み)には渡さない —— 埋め込み先のページには他の要素があり、
     * **こちらが画面の高さを占有してはいけない。**
     */
    fitViewport: true,
  });
  void shell.start();

  // ページ離脱時に WebGL リソースを解放する。
  globalThis.addEventListener('pagehide', () => {
    shell.destroy();
  });
}
